export const GET_FACILITATOR_MAKE = (makeId) => {
  return `facilitator/make/${makeId}`;
};
export const GET_ALL_FACILITATOR_COMPONENTS = (makeId) => {
  return `facilitator/make/${makeId}/components`;
};
export const GET_CLASS_RESULTS = (tournamentId, classId) => {
  return `facilitator/tournament/${tournamentId}/class/${classId}`;
};
